export const UPDATING_SERVICE_DATA = 'UPDATING_SERVICE_DATA';
export const ADD_NEW_SERVICE = 'ADD_NEW_SERVICE';
export const FETCHING_SERVICES = 'FETCHING_SERVICES';
export const CREATING_SERVICE = 'CREATING_SERVICE';
export const UPDATING_SERVICE = 'CREATING_SERVICE';
export const DELETING_SERVICE = 'DELETING_SERVICE';
